<template>
	<Header back :title="props.title" />
	<slot></slot>
	<Footer />
	<Menu />
</template>
<script lang="ts" setup>
import "./AdditionalLayout.scss";
import Footer from "@/components/Footer/Footer.vue";
import Menu from "@/components/Menu/Menu.vue";
import Header from "@/components/Header/Header.vue";

interface Props{
	title : string
}

let props = defineProps<Props>();

</script>